import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiArrowRight} = FiIcons;

const WA='https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20would%20love%20to%20book%20a%20styling%20session.';

function Hero() {
  return (
    <section id="home" className="relative min-h-[92vh] flex items-end overflow-hidden">
      <motion.div
        className="absolute inset-0"
        initial={{scale: 1.1}}
        animate={{scale: 1}}
        transition={{duration: 1.4,ease: 'easeOut'}}
      >
        <img
          src="https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?auto=format&fit=crop&w=1800&q=90"
          alt="Aurelle ladies boutique under warm spotlight"
          className="w-full h-full object-cover"
        />
        {/* Bottom-to-top gradient for text legibility */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#1F1B17] via-[#1F1B17]/45 to-[#1F1B17]/25" />
        {/* Radial spotlight: bright center, dark edges */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 60% 55% at 50% 45%,rgba(31,27,23,0.05) 0%,rgba(31,27,23,0.35) 45%,rgba(31,27,23,0.92) 100%)',
          }}
        />
        {/* Left-side gradient for text block */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1F1B17]/80 via-[#1F1B17]/15 to-transparent" />
      </motion.div>

      <div className="relative z-10 px-6 md:px-12 lg:px-20 pb-20 md:pb-28 max-w-5xl">
        <motion.div
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          transition={{delay: 0.3,duration: 0.8}}
        >
          <p className="eyebrow mb-6" style={{color: '#F7F2EA'}}>
            <span style={{background: '#B87333'}} /> The Rose Edit — Autumn 2025
          </p>
          <h1
            className="font-display text-[clamp(48px,8vw,120px)] leading-[0.95] text-[#F7F2EA] font-light tracking-tight drop-shadow-[0_4px_28px_rgba(31,27,23,0.95)]"
          >
            Worn with<br />
            <em className="italic font-normal text-[#DDB892]">intention.</em>
          </h1>
          <p
            className="mt-8 max-w-md font-sans text-base text-[#F7F2EA] leading-relaxed drop-shadow-[0_2px_16px_rgba(31,27,23,0.95)]"
          >
            Considered silhouettes,honest fabrics and pieces that move the way you do — curated for the modern Indian woman,styled personally over WhatsApp.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href={WA} target="_blank" rel="noreferrer" className="btn-gold">
              Book a styling session
              <SafeIcon icon={FiArrowRight} />
            </a>
            <a
              href="#collections"
              className="btn-outline"
              style={{borderColor: '#F7F2EA',color: '#F7F2EA'}}
            >
              Explore the edit
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute top-1/2 right-8 hidden lg:flex flex-col items-center gap-3 z-10">
        <span
          className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#F7F2EA]/85"
          style={{writingMode: 'vertical-rl'}}
        >
          Scroll to explore
        </span>
        <span className="w-px h-16 bg-[#F7F2EA]/60" />
      </div>
    </section>
  );
}

export default Hero;
